/* LUVORNE store enhancements: shipping progress (PDP + cart), cart summary, colour dots, mobile sticky add-to-cart, "Completa el look".
   Works on top of the theme's own AJAX cart (Impulse). Never replaces checkout or the product form. */
(function () {
  if (window.__lvStore) return;
  window.__lvStore = true;
  var LV = window.LV || {};
  var TH = +LV.threshold || 8900, FEE = +LV.fee || 300, CUR = LV.currency || 'EUR';
  var nf = new Intl.NumberFormat('es-ES', { style: 'currency', currency: CUR });
  var nf0 = new Intl.NumberFormat('es-ES', { style: 'currency', currency: CUR, minimumFractionDigits: 0, maximumFractionDigits: 0 });
  var money = function (c) { return nf.format(c / 100); };
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function setText(root, sel, t) { var e = $(sel, root); if (e && e.textContent !== t) e.textContent = t; }

  var cart = { total: 0, count: 0 }, reqId = 0, timer;

  /* ---------- product data (variant prices, colour map) ---------- */
  function pdpData() { var n = $('[data-lv-product]'); if (!n) return null; try { return JSON.parse(n.textContent); } catch (e) { return null; } }
  function variantId() {
    var i = $('form[action*="/cart/add"] [name="id"]');
    var v = i && i.value;
    if (!v) { v = new URL(location.href).searchParams.get('variant'); }
    return v;
  }
  function pdpPrice() {
    var d = pdpData(); if (!d) return 0;
    var id = variantId();
    return (d.prices && d.prices[id] != null) ? +d.prices[id] : +d.def;
  }

  /* ---------- colour dots instead of product photos (all-or-nothing per swatch group) ---------- */
  function dots() {
    var d = pdpData(); if (!d) return;
    var colors = {};
    Object.keys(d.colors || {}).forEach(function (k) { colors[k.toLowerCase().trim()] = d.colors[k]; });
    var groups = [];
    $$('li.swatch-view-item[orig-value]').forEach(function (li) {
      if (!$('.swatch-image', li)) return;
      var ul = li.closest('ul') || li.parentNode;
      var g = groups.filter(function (x) { return x.ul === ul; })[0];
      if (!g) { g = { ul: ul, items: [] }; groups.push(g); }
      g.items.push(li);
    });
    groups.forEach(function (g) {
      var key = function (li) { return (li.getAttribute('orig-value') || '').toLowerCase().trim(); };
      var known = g.items.every(function (li) { return colors[key(li)]; });
      g.items.forEach(function (li) {
        var im = $('.swatch-image', li);
        if (known) {
          li.classList.add('lv-dot');
          if (im) { im.style.setProperty('background-color', colors[key(li)], 'important'); im.style.setProperty('background-image', 'none', 'important'); }
        } else {
          li.classList.remove('lv-dot');
          if (im) { im.style.removeProperty('background-color'); im.style.removeProperty('background-image'); }
        }
      });
    });
  }

  /* ---------- shipping progress ---------- */
  function renderShip(el) {
    var mode = el.getAttribute('data-mode');
    if (mode === 'cart' && cart.count === 0) { el.hidden = true; return; }
    el.hidden = false;
    var total = cart.total + (mode === 'pdp' ? pdpPrice() : 0);
    var left = TH - total, ok = left <= 0;
    setText(el, '[data-lv-ship-text]', ok ? '¡Ya tienes envío gratis!' : 'Te faltan ' + money(left) + ' para conseguir envío gratis');
    setText(el, '[data-lv-ship-amount]', money(Math.min(total, TH)) + ' / ' + nf0.format(TH / 100));
    var f = $('[data-lv-ship-fill]', el);
    if (f) f.style.width = Math.max(0, Math.min(100, total / TH * 100)) + '%';
  }

  /* ---------- cart summary (drawer + /cart) ---------- */
  function renderSummary(el) {
    var empty = cart.count === 0;
    el.hidden = empty;
    if (empty) return;
    var fee = cart.total >= TH ? 0 : FEE;
    setText(el, '[data-lv-subtotal]', money(cart.total));
    setText(el, '[data-lv-shipping]', fee === 0 ? 'Gratis' : money(fee));
    setText(el, '[data-lv-est]', money(cart.total + fee));
  }

  /* ---------- mobile sticky add-to-cart ---------- */
  var sticky = { bar: null, btn: null, past: false };
  function stickyBlocked() {
    var h = document.documentElement;
    if (h.classList.contains('js-drawer-open') || h.classList.contains('modal-open') || h.classList.contains('cart-open')) return true;
    return !!$('#shopify-pc__banner, .modal--is-active, .popup-open');
  }
  function renderSticky() {
    var s = sticky; if (!s.bar || !s.btn) return;
    var mq = window.matchMedia('(max-width: 749px)').matches;
    var r = s.btn.getBoundingClientRect();
    s.past = r.top < 0 && !(r.bottom > 0);
    setText(s.bar, '[data-lv-sticky-price]', money(pdpPrice()));
    var label = $('[data-add-to-cart-text]', s.btn);
    var b = $('[data-lv-sticky-btn]', s.bar);
    if (b) {
      var txt = label ? label.textContent.replace(/\s+/g, ' ').trim() : '';
      var dis = s.btn.disabled || s.btn.hasAttribute('disabled');
      b.disabled = dis;
      b.textContent = dis && txt ? txt : 'Añadir al carrito';
    }
    s.bar.classList.toggle('is-visible', mq && s.past && !stickyBlocked());
  }
  function initSticky() {
    var bar = $('[data-lv-sticky]'), btn = $('form[action*="/cart/add"] button[data-add-to-cart]') || $('button[data-add-to-cart]');
    if (!bar || !btn) return;
    sticky.bar = bar; sticky.btn = btn;
    var b = $('[data-lv-sticky-btn]', bar);
    if (b) b.addEventListener('click', function () { if (!b.disabled) btn.click(); });
    if (window.MutationObserver) {
      new MutationObserver(renderSticky).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      new MutationObserver(renderSticky).observe(btn, { attributes: true, childList: true, subtree: true });
    }
    var ticking = false;
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(function () { ticking = false; renderSticky(); }); } }, { passive: true });
    window.addEventListener('resize', renderSticky);
    renderSticky();
  }

  /* ---------- Completa el look (explicit add only) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-lv-look-add]');
    if (!b) return;
    e.preventDefault();
    if (b.disabled) return;
    var box = b.closest('[data-lv-look]'), msg = box && $('[data-lv-look-msg]', box);
    b.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +b.getAttribute('data-variant'), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function (j) {
        var item = (j.items && j.items[0]) || j;
        if (msg) msg.textContent = '';
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item }, bubbles: true }));
      })
      .catch(function () { if (msg) msg.textContent = 'No se ha podido añadir el producto. Inténtalo de nuevo.'; })
      .then(function () { b.disabled = false; });
  });

  /* ---------- cart state + rendering ---------- */
  function renderAll() {
    $$('[data-lv-ship]').forEach(renderShip);
    $$('[data-lv-summary]').forEach(renderSummary);
    dots();
    renderSticky();
  }
  function loadCart() {
    var id = ++reqId;
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (id !== reqId) return; cart.total = c.total_price; cart.count = c.item_count; renderAll(); })
      .catch(function () { renderAll(); });
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(loadCart, 120); }

  // refresh after any cart request of the theme or of other scripts
  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function () {
      var a = arguments, u = a[0] && (a[0].url || a[0]);
      var p = nativeFetch.apply(this, a);
      if (/\/cart\/(add|change|update|clear)/.test(String(u))) { p.then(schedule, function () {}); }
      return p;
    };
  }
  ['ajaxProduct:added', 'drawerOpen'].forEach(function (n) { document.addEventListener(n, schedule); });
  window.addEventListener('pageshow', schedule);
  document.addEventListener('change', function () { setTimeout(renderAll, 60); });
  document.addEventListener('click', function () { setTimeout(renderAll, 160); });

  function init() {
    initSticky();
    if (window.MutationObserver) {
      var d = $('#CartDrawer'), page = $('.cart__page');
      var mo = new MutationObserver(schedule);
      if (d) mo.observe(d, { childList: true, subtree: true });
      if (page) mo.observe(page, { childList: true, subtree: true });
      // the swatch app renders late and re-renders on change
      if (pdpData()) {
        var busy = false;
        new MutationObserver(function () { if (busy) return; busy = true; window.requestAnimationFrame(function () { busy = false; dots(); }); })
          .observe($('.product-single__meta') || document.body, { childList: true, subtree: true });
      }
    }
    loadCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
